import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

import Footer from "../../components/Footer";
import TechnologyNavigation from "../../components/technology/TechnologyNavigation";
import TechnologyWhy from "../../components/technology/TechnologyWhy";
import TechnologyCTA from "../../components/technology/TechnologyCTA";
import { technologyServiceMap } from "../../components/technology/serviceConfig";
import {
  WebApplicationSection,
  LandingPageSection,
  DigitalMarketingServiceSection,
  AppDevelopmentSection,
  AnimatedWebsiteSection,
  VideoEditingSection,
} from "../../components/technology/TechnologyServices";

const serviceComponents = {
  "web-applications": WebApplicationSection,
  "landing-pages": LandingPageSection,
  "digital-marketing": DigitalMarketingServiceSection,
  "mobile-apps": AppDevelopmentSection,
  "animated-websites": AnimatedWebsiteSection,
  "video-editing": VideoEditingSection,
};

export default function TechnologyDetail() {
  const { serviceSlug } = useParams();
  const service = technologyServiceMap[serviceSlug];
  const ServiceComponent = serviceComponents[serviceSlug];

  useEffect(() => {
    if (!service) return;

    document.title = service.seoTitle;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = service.seoDescription;
  }, [service]);

  if (!service || !ServiceComponent) {
    return <Navigate to="/technology" replace />;
  }

  return (
    <main className="overflow-hidden bg-[#f6f6f6] text-[#111111]">
      <div className="pt-[100px]">
        <TechnologyNavigation />
      </div>

      <ServiceComponent />
      <TechnologyWhy />
      <TechnologyCTA />
      <Footer />
    </main>
  );
}
